// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { DateTime } from 'luxon'

// Internal Dependencies:
import ProgramTrack from 'components/ProgramTrack/ProgramTrack'
import { getUtcTimestampSeconds } from 'utilities/time'

// Redux:
import { likeProgram } from 'actions/site'

class ProgramFavourite extends React.Component {
	constructor( props ) {
		super( props )

		let state = {
			showAll: false
		}

		this.state = state
	}

	handleToggleAll = () => {
		this.setState( {
			showAll: ! this.state.showAll
		} )
	}

	getPlaylist = ( podcastsItems ) => {
		let returnValue = []
		const { data, rewindMaxHours } = this.props
		const utcTimestampSeconds = getUtcTimestampSeconds()

		podcastsItems.forEach( ( item, i ) => {
			let lastPlayedSecondsAgo = utcTimestampSeconds - parseInt( item.last_played_timestamp_gmt, 10 )
			let lastPlayedHoursAgo = lastPlayedSecondsAgo / 60 / 60
			let canPlay = ( data.podcasts_enabled || lastPlayedHoursAgo <= rewindMaxHours )

			if ( canPlay ) {
				returnValue.push( {
					is_playlist: true,
					audio_file_url: item.url,
					seconds: parseInt( item.seconds ),
					title: item.title,
					series: data.title,
					series_slug: data.slug,
					guests: item.guests
				} )
			}
		} )

		return returnValue
	}

	renderFavourites = () => {
		const { data, accountData, rewindMaxHours, likesOverride, skipSearchCheck, filterCategory } = this.props
		const { playingPodcast, playingPodcastFile, showAll } = this.state
		const likesData = likesOverride ? likesOverride : accountData.likes
		const filterSearch = this.props.filterSearch.toLowerCase()

		let markup = [],
			items = [],
			allItems = []

		if ( ! likesData || ! Object.keys( likesData ).length ) {
			return null
		}

		Object.keys( likesData ).forEach( key => {
			let item = likesData[ key ]

			// Check associated program series:
			if ( ! likesOverride && item.series_slug != data.slug ) {
				return
			}

			// Check filter category:
			if ( filterCategory && data.categories && data.categories.indexOf( filterCategory ) === -1 ) {
				return
			}

			// Check search term:
			if ( filterSearch && ! skipSearchCheck ) {
				let titleLower = item.title.toLowerCase()

				if ( titleLower.indexOf( filterSearch ) === -1 ) {
					return
				}
			}

			items.push( item )
		} )

		if ( ! items.length ) {
			return null
		}

		// Sort:
		items.sort( ( a, b ) => {
		    // Date:
		    if ( a.number_timestamp ) {
		    	let nA = parseFloat( a.number_timestamp )
		    	let nB = parseFloat( b.number_timestamp )

		    	if ( nA && nB ) {
		    		if ( nA < nB ) {
		    			return 1
		    		}

		    		if ( nA > nB ) {
		    			return -1
		    		}
		    	}

		    	return 0
		    }

		    // Number:
		    let nA = parseFloat( a.number )
		    let nB = parseFloat( b.number )

		    if ( nA && nB ) {
		    	if ( nA < nB ) {
		    		return 1
		    	}

		    	if ( nA > nB ) {
		    		return -1
		    	}
		    }

		    return 0
		} )

		const count = items.length
		allItems = items

		if ( ! showAll ) {
			items = items.slice( 0, 3 )
		}

		const playlist = this.getPlaylist( allItems )

		markup = items.map( ( item, i ) => {
			item.series = data.title
			let isLast = i == items.length - 1
			let playlistCurrentIndex = playlist.findIndex( o => o.audio_file_url === item.url )
			let isLiked = ! item.is_removed

			return <ProgramTrack
				key={ item.url }
				data={ item }
				programData={ data }
				isLast={ isLast }
				isLiked={ isLiked }
				isFavourites={ true }
				playlist={ {
					playlist: playlist,
					currentIndex: playlistCurrentIndex
				} }
			/>
		} )

		markup = markup.filter( Boolean )

		if ( ! markup.length ) {
			return null
		}

		return (
			<div className="program-podcasts">
				<div className="schedule-programs-wrap">
					<div className="-programs">
						{ markup }
					</div>
				</div>

				{ count > 3 &&
					<div className="-show">
						{ showAll &&
							<div className="button -small" onClick={ this.handleToggleAll }>
								<span className="-toggle-icon has-visible"><i className="icon-chevron-left"></i><i className="icon-chevron-right"></i></span> <span>Show less</span>
							</div>
						||
							<div className="button -small" onClick={ this.handleToggleAll }>
								<span className="-toggle-icon"><i className="icon-chevron-left"></i><i className="icon-chevron-right"></i></span> <span>Show all</span>
							</div>
						}
					</div>
				}
			</div>
		)
	}

	render() {
		const { data, favourite, timezone } = this.props
		const { playingPodcast, playingPodcastFile } = this.state
		const favouritesMarkup = this.renderFavourites()

		if ( ! favouritesMarkup ) {
			return null
		}

		return (
			<div className="program-item-favourite">
				<Link to={ `/program/${ data.slug }` } className="-thumb">
					<div className="-inner">
						<div className="-image">
							{ data.featured_image_index.url &&
								<img src={ data.featured_image_index.url } srcSet={ data.featured_image_index.srcset } alt={ data.featured_image_index.alt } />
							}
						</div>

						<div className="-info">
							<header>
								<h3 dangerouslySetInnerHTML={ { __html: data.title } } />
							</header>
						</div>
					</div>
				</Link>

				<div className="-favourites-info">
					<div className="-inner">
						{ favouritesMarkup }
					</div>
				</div>

				<div className="-player">
					{ playingPodcastFile &&
						<FilePlayer
							ref={ ( e ) => { this.player = e } }
							url={ playingPodcastFile }
							playing={ playingPodcast }
							playsinline={ true }
						/>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		timezone: state.schedule.timezone,
		accountData: state.site.accountData,
		rewindMaxHours: state.schedule.rewindMaxHours,
		filterSearch: state.programs.filterSearch,
		filterCategory: state.programs.filterCategory
	}
}

export default connect( mapStateToProps )( ProgramFavourite )
